import {TypeLangue} from './TypeLangue';
export class Conditions {

	public euro: string;

	public autresConditionsNon: string;

	public modFinancement: string;

	public formeJuridique: string;

	public garanties: string;

	public langueFR: string;

	public langue: TypeLangue;

	public autresConditionsOui: string;

	constructor() { 
		 		this.euro = '';
		this.autresConditionsNon = '';
		this.modFinancement = '';
		this.formeJuridique = '';
		this.garanties = '';
		this.langueFR = '';
		this.langue = new TypeLangue();
		this.autresConditionsOui = '';
 
	}
}
